import { createApp } from "vue";

// Import stylesheets
import "vuetify/styles";
import "./tailwind.css";

// 3rd party libraries
import vuetify from "./plugins/vuetify";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Vue3TouchEvents, { type Vue3TouchEventsOptions } from "vue3-touch-events";
import { LoadingPlugin } from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import VueGoogleMaps from "vue-google-maps-community-fork";

// Application logic
import store from "./store";
import App from "./App.vue";
import router from "./router";
import { datadogRum } from "@datadog/browser-rum";
import {
    createInactivityCheck,
    handleAppInitialization,
    handleSSOAuthorizationCode,
} from "./lib/auth";

datadogRum.init({
    applicationId: "78118c14-84ec-478d-ba75-d30f373a567e",
    clientToken: "pub53bdeafac37b27fc0b8691489f28e7d3",
    site: "datadoghq.com",
    service: "invaiolab-test",
    env: "test",
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
});
datadogRum.startSessionReplayRecording();

function loadApp() {
    const app = createApp(App);
    app.use(router);
    app.use(store);
    app.use(vuetify);
    app.use<Vue3TouchEventsOptions>(Vue3TouchEvents, {});
    app.use(Toast, {});
    app.use(LoadingPlugin, {
        color: "#1976d2",
    });
    app.use(VueGoogleMaps, {
        load: {
            key: "AIzaSyAp9NDj4_C7jdprSYb1X2ykxvvUpQ09aGc", // Invaio Google API Key
        },
    });
    app.config.errorHandler = (err, vm, info) => {
        console.error(err, vm, info);
    };

    app.mount("#app");
}

function init() {
    handleAppInitialization()
        .then(() => {
            loadApp();
        })
        .catch((err) => {
            // This really shouldn't happen unless lab-api down
            console.error("Failed to initialize app", err);
        });
}

createInactivityCheck(store, document.body.addEventListener);

const uri = window.location.search.substring(1);
const params = new URLSearchParams(uri);
if (params.has("code")) {
    // lab-api verifies the authorization code and exchanges for auth tokens
    handleSSOAuthorizationCode(params.get("code"))
        .then((redirectUrl) => {
            // when successful, redirect the user to the original location (or home)
            // This removes `?code=...` from the browser location so it doesn't stick around.
            window.location = redirectUrl;
        })
        .catch(() => {
            window.history.replaceState({}, document.title, "/#");
            // load up the app to show the error message in the UI
            init();
        });
} else {
    init();
}
